import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useConnectedWalletName } from 'modules/wallet/hooks/useConnectedWalletName'
import { useSwitchNetwork } from 'modules/wallet/hooks/useSwitchNetwork'

import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'

import s from './UnsupportedChainBanner.module.scss'

export function UnsupportedChainBanner() {
  const { isChainUnsupported } = useWeb3()
  const switchNetwork = useSwitchNetwork()
  const connectedWalletName = useConnectedWalletName()

  if (!isChainUnsupported) {
    return null
  }

  return (
    <div className={s.wrap}>
      <div className={s.banner}>
        <div className={s.bannerInner}>
          <Text size={14} weight={500} className={s.text}>
            Your wallet is connected to the chain that is not supported
            {connectedWalletName !== 'metamask' &&
              '. Please switch chain on your wallet app, and reconnect it.'}
          </Text>
          {connectedWalletName === 'metamask' && (
            <Button size={40} fashion="glass" onClick={switchNetwork}>
              Switch network
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
